/**
 * @desc 解析选择控件选择完成之后，进行解析
 * @param {*} value value.addres 地址 
 */
const analysisAddress = function(res){
  let value = JSON.parse(JSON.stringify(res));
  if(!value || !value.addressSelect) return value;
  let address = value.addressSelect;
  if(address.length >= 1){
    value.provinceId = address[0];
  }

  if(address.length >= 2){
    value.cityId = address[1];
  }

  if(address.length >= 3){
    value.districtId = address[2];
  }
  delete value.addressSelect;
  return value;
}

export {
  analysisAddress,
}